/**
 * Hide Swiper controls when there aren't enough slides for the current `slidesPerView`.
 *
 * This theme uses minimal Swiper base CSS, so we can't rely on Swiper's default
 * `.swiper-button-lock` / `.swiper-pagination-lock` styles.
 */
export default function updateSwiperControlsVisibility(swiper, opts = {}) {
	if (!swiper || swiper.destroyed) return;

	const {
		sliderEl = swiper.el,
		sectionEl = sliderEl,
		controlsEl = sectionEl ? sectionEl.querySelector('.cards-swiper-controls') : null,
		paginationEl = sectionEl ? sectionEl.querySelector('.swiper-pagination') : null,
		nextEl = sectionEl ? sectionEl.querySelector('.swiper-button-next') : null,
		prevEl = sectionEl ? sectionEl.querySelector('.swiper-button-prev') : null,
	} = opts;

	const slidesPerViewRaw = swiper.params && swiper.params.slidesPerView;
	const slidesPerView =
		typeof slidesPerViewRaw === 'number' ? slidesPerViewRaw : Number(slidesPerViewRaw);
	if (!slidesPerView || Number.isNaN(slidesPerView)) return;

	// Count only real slide elements in the wrapper.
	const wrapperEl =
		swiper.wrapperEl || (sliderEl ? sliderEl.querySelector('.swiper-wrapper') : null);
	let slidesCount = 0;
	if (wrapperEl) {
		slidesCount = Array.from(wrapperEl.children).filter((el) => {
			if (!(el instanceof HTMLElement)) return false;
			if (!el.classList.contains('swiper-slide')) return false;
			if (el.classList.contains('swiper-slide-duplicate')) return false;
			return true;
		}).length;
	} else if (sliderEl) {
		slidesCount = sliderEl.querySelectorAll('.swiper-slide').length;
	}

	// Prefer Swiper's overflow lock state when available.
	const isLocked = typeof swiper.isLocked === 'boolean' ? swiper.isLocked : undefined;
	const shouldShowControls = isLocked === true ? false : slidesCount > slidesPerView;

	// We can't rely on the HTML `hidden` attribute here because theme CSS sets
	// `display` with higher specificity. Inline style wins.
	function toggle(el, show) {
		if (!el) return;
		if (show) {
			el.style.removeProperty('display');
			el.removeAttribute('aria-hidden');
		} else {
			el.style.display = 'none';
			el.setAttribute('aria-hidden', 'true');
		}
	}

	[paginationEl, nextEl, prevEl].forEach((el) => toggle(el, shouldShowControls));

	// If the controls are in their own wrapper, hide that too to avoid empty spacing.
	if (controlsEl && controlsEl !== sliderEl) {
		toggle(controlsEl, shouldShowControls);
	}
}
